/* eslint-disable @typescript-eslint/no-explicit-any */
import { IUser, IUserCreationPayload } from "../types/user";
import backendApi from "./backendApi";
import { showSnackbar } from "./snackbar.service";

const routePrefix = "user";

export default {
  async getMyProfile(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/my-profile`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load your profile."
        );
        return null;
      }
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load your profile."
        );
        return null;
      }
    }
  },
  async fetchAllUsers(): Promise<any> {
    try {
      const result = await backendApi()?.get(`${routePrefix}/all`);
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not load the users."
        );
        return null;
      }
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not load the users."
        );
        return null;
      }
    }
  },
  async deleteUser(userId: string): Promise<any> {
    try {
      const result = await backendApi()?.delete(
        `${routePrefix}/delete/${userId}`
      );
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not delete the user."
        );
        return null;
      }
    }
  },
  async checkUserExists(email: string): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/exists`, {
        email,
      });
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not check whether that user exists."
        );
        return null;
      }
    }
  },
  async addNewUser(userInfo: IUserCreationPayload): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/create`, {
        ...userInfo,
      });
      if (result?.status != 200) {
        showSnackbar(
          "danger",
          "Error",
          result?.data.message || "Could not save the user."
        );
        return null;
      }
      showSnackbar(
        "success",
        "Success",
        result?.data.message || "User created."
      );
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not save the user."
        );
        return null;
      }
    }
  },
  async updateUser(user: IUser): Promise<any> {
    try {
      const result = await backendApi()?.post(`${routePrefix}/update`, {
        user,
      });
      showSnackbar(
        "success",
        "Success",
        result?.data.message || "User updated."
      );
      return result;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not update the user."
        );
        throw error;
      }
    }
  },
  async sendContactSupportMessage(
    subject: string,
    message: string
  ): Promise<any> {
    try {
      const result = await backendApi()?.post(
        `${routePrefix}/contact-support`,
        {
          subject,
          message,
        }
      );
      showSnackbar("success", "", "Message sent.");
      return result.data;
    } catch (error: any) {
      if (error?.response?.status) {
        showSnackbar(
          "danger",
          "Error",
          error?.response?.data?.message || "Could not send your message."
        );
        return null;
      }
    }
  },
};
